import axios from "axios";

export const v4_job_description_generator = async (payload) => {
    const url = `https://ai.akshaki.com/v3/jobzshala/generateJd`;
    return axios.post(url, payload).then((res) => {
        return res.data;
    })

}